// src/utils/proofGate.ts
// Pure client-side mirror of the server proof gate. Blocks a transition INTO
// `done` when the task requires proof but has none attached. Re-saving an
// already-done task is never blocked. The server remains authoritative.

export interface ProofGateOpts {
  /** Status before the change (the persisted task's status). */
  prevStatus?: string | null;
  /** Status being applied. */
  nextStatus?: string | null;
  proofRequired?: boolean;
  proofCount: number;
}

export function isCompletionBlockedByProof({
  prevStatus,
  nextStatus,
  proofRequired,
  proofCount,
}: ProofGateOpts): boolean {
  if (!proofRequired) return false;
  if (nextStatus !== 'done') return false;
  if (prevStatus === 'done') return false;
  return proofCount <= 0;
}
